var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperationFacturation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1770_2386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6399 7C8.22141 7 3 12.2221 3 18.6406C3 25.0591 8.22135 30.2805 14.6399 30.2805C21.0588 30.2805 26.2805 25.0592 26.2805 18.6406C26.2805 12.2221 21.0588 7 14.6399 7ZM14.6399 28.4444C9.23414 28.4444 4.83609 24.0464 4.83609 18.6406C4.83609 13.2341 9.23414 8.83609 14.6399 8.83609C20.0464 8.83609 24.4444 13.2341 24.4444 18.6406C24.4444 24.0464 20.0465 28.4444 14.6399 28.4444Z",
    fill: "#176318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8899 14.7788C17.0391 14.7788 17.9198 15.0841 18.8898 15.4968L19.141 13.4671C18.225 13.0183 17.0391 12.8027 15.8899 12.8027C13.1599 12.8027 11.0224 14.4374 10.376 17.0777H9.06436L8.56115 18.5322H10.1782V18.7838C10.1782 19.1252 10.1962 19.4664 10.2319 19.7718H8.57955L8.04102 21.3167H10.627C11.4892 23.4722 13.4652 24.7648 15.89 24.7648C17.0392 24.7648 18.2251 24.5493 19.141 24.1005L18.8898 22.0707C17.9198 22.4842 17.0392 22.7896 15.89 22.7896C14.5607 22.7896 13.6447 22.2503 13.1055 21.3167H16.3929L16.9317 19.7718H12.603C12.5486 19.4664 12.5309 19.1435 12.5309 18.7838V18.5322H16.7339L17.2731 17.0777H12.7648C13.1952 15.6763 14.2016 14.7788 15.8899 14.7788Z",
    fill: "#176318"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1770_2386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationFacturation);
export default __webpack_public_path__ + "static/media/OperationFacturation.a8a75450419d455229e0b0b92e19d39c.svg";
export { ForwardRef as ReactComponent };